import { Injectable, ViewChildren, QueryList } from '@angular/core';
import { IonRouterOutlet, ActionSheetController, PopoverController, ModalController, MenuController, ToastController } from '@ionic/angular/standalone';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AutocloseOverlaysService {
  constructor(
    private actionSheetCtrl: ActionSheetController,
    private popoverCtrl: PopoverController,
    private modalCtrl: ModalController,
    private menu: MenuController,
  ) { }
  async trigger(state?: { [k: string]: any; }) {
    console.log('backbutton triggered');
    // close action sheet
    try {
      const element = await this.actionSheetCtrl?.getTop();
      if (element) {
        element?.dismiss();
        return true;
      }
    } catch (error) {
      console.error(error)
    }

    // close popover
    try {
      const element = await this.popoverCtrl?.getTop();
      if (element) {
        element?.dismiss();
        return true;
      }
    } catch (error) {
      console.error(error)
    }

    // close modal
    try {
      const element = await this.modalCtrl?.getTop();

      // quest'if serve per non chiudere modali e per non cambiare pagina. La dismiss
      // deve funzionare solo con la dismiss delle modali
      if (!!(element as any)?.componentProps?.isNotDismissableWithBack) {
        console.log('AAA ELEMENT', element?.componentProps)
        return true;
      }
      if (element) {
        element?.dismiss();
        return true;
      }
    } catch (error) {
      console.error(error)
    }

    // close side menu
    if(!state?.['skip']) {
      try {
        const element = await this.menu?.getOpen();
        if (element != null) {
          this.menu?.close();
          return true;
        }
      } catch (error) {
        console.error(error)
      }
    }
    return false;
  }


}
